import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const ARTCAST_LEDGER_ITEMS_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/ledger-items',
        iconClass: 'fas fa-clipboard',
        name: 'Ledgers',
        layout: eLayoutType.application,
        requiredPolicy: 'Artcast.Ledgers',
        order: 6
      },
    ]);
  };
}
